<script setup lang="ts">
import Skeleton from 'primevue/skeleton'
</script>

<template>
  <article>
    <header>
      <h3><Skeleton width="50%" height="24px" /></h3>
    </header>
    <p><Skeleton width="20%" /></p>
  </article>
</template>

<style scoped>
article {
  box-shadow: var(--card-shadow);
  border-radius: var(--border-radius);
  background-color: #fff;
  padding: var(--section-padding);
  border-bottom: 1px solid #eeeeee;
}

article header {
  padding-bottom: var(--section-padding);
  margin-bottom: var(--section-padding);
  border-bottom: 1px solid #eeeeee;
}
</style>
